/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, color="908E8D" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.8 21.125C5.3 21.125 4.875 20.95 4.525 20.6C4.175 20.25 4 19.825 4 19.325V5.925C4 5.425 4.175 5 4.525 4.65C4.875 4.3 5.3 4.125 5.8 4.125H7.2V2.75C7.2 2.53333 7.27067 2.354 7.412 2.212C7.554 2.07067 7.73333 2 7.95 2C8.18333 2 8.37067 2.075 8.512 2.225C8.654 2.375 8.725 2.55833 8.725 2.775V4.125H16.3V2.725C16.3 2.525 16.375 2.354 16.525 2.212C16.675 2.07067 16.85 2 17.05 2C17.2667 2 17.4457 2.075 17.587 2.225C17.729 2.375 17.8 2.55 17.8 2.75V4.125H19.2C19.7 4.125 20.125 4.3 20.475 4.65C20.825 5 21 5.425 21 5.925V19.325C21 19.825 20.825 20.25 20.475 20.6C20.125 20.95 19.7 21.125 19.2 21.125H5.8ZM5.8 19.625H19.2C19.2833 19.625 19.3543 19.596 19.413 19.538C19.471 19.4793 19.5 19.4083 19.5 19.325V9.925H5.5V19.325C5.5 19.4083 5.52933 19.4793 5.588 19.538C5.646 19.596 5.71667 19.625 5.8 19.625ZM5.5 8.425H19.5V5.925C19.5 5.84167 19.471 5.771 19.413 5.713C19.3543 5.65433 19.2833 5.625 19.2 5.625H5.8C5.71667 5.625 5.646 5.65433 5.588 5.713C5.52933 5.771 5.5 5.84167 5.5 5.925V8.425Z"
      fill={color? color : "#908E8D"}/>
  </svg>
);

export default SvgComponent;
